import type { components } from "./generated/trading-engine.js";

export type ApiResource = components["schemas"]["Resource"];

export function stringField(resource: ApiResource, field: string, fallback = ""): string {
  const value = resource[field];
  return typeof value === "string" ? value : fallback;
}

export function stringArrayField(resource: ApiResource, field: string): readonly string[] {
  const value = resource[field];
  return Array.isArray(value)
    ? value.filter((item): item is string => typeof item === "string")
    : [];
}
